{
  "tags": [
    {
      "name": "font",
      "description": "Changes the font for subsequent text. If no valid font is specified or Argument 1 is missing, reverts to default font.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Font name to switch to (must exist in Game1.fonts dictionary)"
        }
      ],
      "aliases": []
    },
    {
      "name": "subtitle1",
      "description": "Creates a subtitle line with specified font, displaying dialog string elements. Only works if text doesn't start with '('. Adjusts string to fit within maxWidth.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Font name for the subtitle (uses default font if not in Game1.fonts)"
        }
      ],
      "optional": [],
      "aliases": ["sub1", "s1"]
    },
    {
      "name": "subtitle2",
      "description": "Moves to next line and resets font to default, clearing text. Only works if text doesn't start with '('.",
      "required": [],
      "optional": [],
      "aliases": ["sub2", "s2"]
    },
    {
      "name": "speed",
      "description": "Sets the text animation speed multiplier for subsequent text. Empty or missing value resets to 1.0x speed.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Speed multiplier value (float). If empty or missing, resets to 1.0"
        }
      ],
      "aliases": []
    },
    {
      "name": "pause",
      "description": "Inserts a pause command in text animation with configurable duration. Default pause is 0.7 seconds.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Pause duration in seconds (float). Defaults to 0.7 if empty or missing"
        }
      ],
      "aliases": ["p"]
    },
    {
      "name": "title",
      "description": "Centers text horizontally and adds a newline. The text content is taken from Argument 1.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text to display centered"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "indent",
      "description": "Indents text by 25% of remaining width and adds newline. The text content is taken from Argument 1.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text to display indented"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "image",
      "description": "Displays an image at normal size, centered horizontally on a new line. Validates texture exists before displaying.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures)"
        }
      ],
      "optional": [],
      "aliases": ["img"]
    },
    {
      "name": "imgBig",
      "description": "Displays an image at 2x size (width and height doubled), centered horizontally on a new line. Validates texture exists.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "imgHuge",
      "description": "Displays an image at 3x size (width and height tripled), centered horizontally on a new line. Validates texture exists.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "img_g",
      "description": "Displays an image where the texture name is retrieved from a global variable. Skips display if variable is empty or '0'. Centered on new line.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing the texture key"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "imgIf",
      "description": "Conditionally displays an image based on formula evaluation. Shows image only if formula result is > 0 and texture name is not empty or '0'. Centered on new line.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures)"
        },
        {
          "name": "Argument 2",
          "description": "Formula condition - image displays only if result > 0 and not empty string"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "icon",
      "description": "Displays an icon texture inline at normal size. Wraps to next line if doesn't fit. Validates texture exists.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "thinIcon",
      "description": "Displays an icon with width reduced by 3 pixels and shifted left. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "thinnerIcon",
      "description": "Displays an icon with width reduced by 5 pixels and shifted further left. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "iconLow",
      "description": "Displays an icon positioned 2 pixels lower than normal. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": ["icon_low"]
    },
    {
      "name": "iconBig",
      "description": "Displays an icon at 2x size (width and height doubled). Takes up more horizontal space. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": ["icon_big"]
    },
    {
      "name": "iconBig_low",
      "description": "Displays an icon at 2x size positioned 2 pixels lower. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "icon_action",
      "description": "Displays an action's icon with its associated color palettes. Retrieves icon from Data.actions dictionary. Width increased by 2 pixels.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Action ID in Data.actions dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "icon_support",
      "description": "Displays a support ability's icon. Retrieves icon from Data.supportAbilities dictionary. Width increased by 2 pixels.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Support ability ID in Data.supportAbilities dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "icon_tiny",
      "description": "Displays an icon at half size (0.5x), shifted left by 4 pixels and down by 4 pixels, with width reduced by 8 pixels.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "iconNoWrap",
      "description": "Displays an icon inline without wrapping to a new line if it doesn't fit. Uses addIcon helper function.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name to display"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "background",
      "description": "Displays a background texture at 2x size, centered horizontally, inserted at the beginning of texture list (drawn behind other elements). Skips if no argument is given.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Required but checked as optional due to length check"
        }
      ],
      "aliases": ["bg"]
    },
    {
      "name": "bgIf",
      "description": "Conditionally displays a background texture based on formula evaluation. Shows only if formula > 0. Background is 2x size, centered horizontally.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures). Skips if empty"
        },
        {
          "name": "Argument 2",
          "description": "Formula condition - background displays only if result > 0 and not empty string"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "bgX0",
      "description": "Displays a background texture at 2x size with X position set to 0 (left-aligned) instead of centered. Inserted at beginning of texture list.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Texture key name (must exist in Game1.textures)"
        }
      ],
      "aliases": []
    },
    {
      "name": "gbg",
      "description": "Displays a background texture where texture name is retrieved from global variable. Skips if variable value is '0' or empty. Background is 2x size, centered.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing texture key"
        }
      ],
      "aliases": []
    },
    {
      "name": "gbgX0",
      "description": "Displays a background texture from global variable with X position set to 0 (left-aligned). Skips if variable value is '0' or empty. Background is 2x size.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing texture key"
        }
      ],
      "aliases": []
    },
    {
      "name": "item",
      "description": "Displays an item icon inline from Data.itemTypes. Shows sprite with item's color palettes. Wraps to next line if doesn't fit. Skips if item doesn't exist.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "item_low",
      "description": "Displays an item icon positioned 3 pixels lower than normal. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "item_global",
      "description": "Displays an item icon where item type ID is retrieved from a global variable. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "item_global_low",
      "description": "Displays an item icon from global variable, positioned 3 pixels lower. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig",
      "description": "Displays an item icon at 2x size. Handles special item sprite properties (2x width/height). Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig_low",
      "description": "Displays an item icon at 2x size, positioned 6 pixels lower. Handles special sprite properties.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig_global",
      "description": "Displays an item icon at 2x size where item type ID is retrieved from global variable. Handles special sprite properties.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig_global_low",
      "description": "Displays an item icon at 2x size from global variable, positioned 6 pixels lower. Handles special sprite properties.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig_lower",
      "description": "Displays an item icon at 2x size, positioned 8 pixels lower (more than _low variant). Handles special sprite properties.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemBig_global_lower",
      "description": "Displays an item icon at 2x size from global variable, positioned 8 pixels lower. Handles special sprite properties.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemName",
      "description": "Displays the name of an item from Data.itemTypes dictionary.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemName_global",
      "description": "Displays the name of an item where item type ID is retrieved from a global variable.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemValue",
      "description": "Displays the base value (price) of an item as a number string.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "itemValue_global",
      "description": "Displays the base value of an item where item type ID is retrieved from a global variable.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name containing item type ID"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "buyPrice",
      "description": "Displays the buy price of an item (may differ from base value). Uses getBuyPrice() method.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID in Data.itemTypes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "actor",
      "description": "Displays an actor sprite at normal size. Supports party index or actor ID. Uses default sprite with palettes. Wraps to next line if doesn't fit.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer). If integer, retrieves from partyActors"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation (integer). Only used if actor type doesn't have noFacingRotRows"
        }
      ],
      "aliases": []
    },
    {
      "name": "actor_low",
      "description": "Displays an actor sprite at normal size, positioned 6 pixels lower. Supports party index or actor ID.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorBig",
      "description": "Displays an actor sprite at 2x size. Supports party index or actor ID. Uses default sprite with palettes.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorBig_low",
      "description": "Displays an actor sprite at 2x size, positioned 6 pixels lower. Supports party index or actor ID.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "portrait",
      "description": "Displays an actor's portrait (head sprite and optional face sprite) at normal size. Checks living actors and dead actors. Uses pDead palette if actor is dead.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "portraitBig",
      "description": "Displays an actor's portrait (head and face sprites) at 2x size. Checks living and dead actors.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID or party index (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "portraitCommodore",
      "description": "Displays the portrait of the fleet's commodore at normal size. Automatically retrieves commodore from actor's fleet.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID (gets overwritten with commodore's ID internally)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "portraitBigCommodore",
      "description": "Displays the portrait of the fleet's commodore at 2x size. Automatically retrieves commodore from actor's fleet.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID (gets overwritten with commodore's ID internally)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorPFleet",
      "description": "Displays an actor sprite from player fleet's boats at normal size. Uses boat index to retrieve actor.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer, gets converted to boat's actorTypeID)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorPFleet_low",
      "description": "Displays an actor sprite from player fleet's boats at normal size, positioned 6 pixels lower.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorBigPFleet",
      "description": "Displays an actor sprite from player fleet's boats at 2x size.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "actorBigPFleet_low",
      "description": "Displays an actor sprite from player fleet's boats at 2x size, positioned 6 pixels lower.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer)"
        }
      ],
      "optional": [
        {
          "name": "Argument 2",
          "description": "Facing direction row index for sprite animation"
        }
      ],
      "aliases": []
    },
    {
      "name": "linebreak",
      "description": "Inserts a horizontal line separator (breakLine texture) with configurable width. Default width is 60% of maxWidth. Moves to new line with 5 pixel spacing.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Line width in pixels (float). Defaults to maxWidth * 0.6 if empty or missing"
        }
      ],
      "aliases": ["br", "lineBreak"]
    },
    {
      "name": "br_brown",
      "description": "Inserts a brown horizontal line separator (breakLine_brown texture) with configurable width. Default width is 60% of maxWidth. Moves to new line with 5 pixel spacing.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Line width in pixels (float). Defaults to maxWidth * 0.6 if empty or missing"
        }
      ],
      "aliases": []
    },
    {
      "name": "n",
      "description": "Moves to a new line (newline). Resets X position to 0 and advances Y by line height.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "hn",
      "description": "Moves down by half a line height (half newline). Resets X position to 0 and advances Y by floor(lineHeight/2).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "brAdj",
      "description": "Inserts a horizontal line separator centered at 25% from left. Advances Y by 5 pixels. Default width is 60% of maxWidth.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Line width in pixels (float). Uses this value directly (no default if empty, will cause parse error)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "math",
      "description": "Evaluates a formula and displays the result as a string. Floors the result to integer. Uses actor context if available.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Formula string to evaluate. If missing, displays empty string"
        }
      ],
      "aliases": []
    },
    {
      "name": "mathMin0",
      "description": "Evaluates a formula, floors to integer, and displays max(0, result). Never shows negative values.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Formula string to evaluate. If missing, displays empty string"
        }
      ],
      "aliases": []
    },
    {
      "name": "mathInt",
      "description": "Evaluates a formula, applies floor function, and displays the integer result.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Formula string to evaluate. If missing, displays empty string"
        }
      ],
      "aliases": []
    },
    {
      "name": "mathDecimal",
      "description": "Evaluates a formula and displays the result with decimal precision (not floored). Uses actor context.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Formula string to evaluate"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "xAdj",
      "description": "Adjusts the X position by a specified amount (adds to current X).",
      "required": [
        {
          "name": "Argument 1",
          "description": "X offset value in pixels (float, can be negative)"
        }
      ],
      "optional": [],
      "aliases": ["adjX"]
    },
    {
      "name": "yAdj",
      "description": "Adjusts the Y position by a specified amount (adds to current Y).",
      "required": [
        {
          "name": "Argument 1",
          "description": "Y offset value in pixels (float, can be negative)"
        }
      ],
      "optional": [],
      "aliases": ["adjY"]
    },
    {
      "name": "adjImgX",
      "description": "Adjusts the X position offset for all subsequent images/textures (adds to zero2.X).",
      "required": [
        {
          "name": "Argument 1",
          "description": "X offset value in pixels (float, can be negative)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "adjImgY",
      "description": "Adjusts the Y position offset for all subsequent images/textures (adds to zero2.Y).",
      "required": [
        {
          "name": "Argument 1",
          "description": "Y offset value in pixels (float, can be negative)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "setX",
      "description": "Sets the X position to an absolute value.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Absolute X position in pixels (float)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "setY",
      "description": "Sets the Y position to an absolute value.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Absolute Y position in pixels (float)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "baseX",
      "description": "Sets both the current X position and the base X position (used for line wrapping) to an absolute value.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Absolute X position in pixels (float)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "centerText",
      "description": "Centers the specified text horizontally within the available width. Adjusts X position to center the text.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text string to center"
        }
      ],
      "optional": [],
      "aliases": ["center"]
    },
    {
      "name": "centerAll",
      "description": "Centers all previously rendered text and textures horizontally. Can snap to grid and specify custom width. Adjusts all existing positions.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Grid snap value in pixels (float). Centers are rounded to nearest multiple of this value"
        },
        {
          "name": "Argument 2",
          "description": "Total width to center within (float). Defaults to getWidth() if not specified"
        }
      ],
      "aliases": []
    },
    {
      "name": "center2Digit",
      "description": "Centers text assuming it's a 2-digit number. Adjusts position for single-digit numbers to align properly. Removes spaces from first text element.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "rightAdjusted",
      "description": "Right-aligns all previously rendered text by shifting positions based on content width. Aligns to even pixel boundaries.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "adjXScaled",
      "description": "Adjusts X offset and reduces maxWidth based on screen scale. Adds horizontal padding that scales with screen size. Adds 20px at scale > 1, otherwise 0.25 * (screenWidth - 800) capped at 0.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "adjYScaled",
      "description": "Adjusts Y offset for text and images when screen scale > 1. Sets both zero.Y and zero2.Y to -90 if scale > 1.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "adjMaxWidth",
      "description": "Adjusts the maximum width by adding a specified value scaled by tooltip scale factor.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Width adjustment value (float, multiplied by Globals.tooltipScale)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "textIf",
      "description": "Conditionally displays text based on formula evaluation. Shows text only if formula result > 0.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text to display if condition is true"
        },
        {
          "name": "Argument 2",
          "description": "Formula condition - text displays only if result > 0"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "textIfElse",
      "description": "Displays one of two text strings based on formula evaluation (if-else). Shows Argument 1 if formula > 0, otherwise shows Argument 2.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text to display if condition is true"
        },
        {
          "name": "Argument 2",
          "description": "Text to display if condition is false"
        },
        {
          "name": "Argument 3",
          "description": "Formula condition - determines which text to show"
        }
      ],
      "optional": [],
      "aliases": ["textIf2"]
    },
    {
      "name": "textIfFinal",
      "description": "Conditionally displays text and stops all further tag processing if condition is true. Sets flag2=true to end processing. Shows text only if formula > 0.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Text to display if condition is true (also terminates processing)"
        },
        {
          "name": "Argument 2",
          "description": "Formula condition - text displays and processing stops only if result > 0"
        }
      ],
      "optional": [],
      "aliases": ["finalTextIf"]
    },
    {
      "name": "rand",
      "description": "Randomly selects and displays one option from a slash-separated list. Uses current Game1.random state (not seeded).",
      "required": [
        {
          "name": "Argument 1",
          "description": "Slash-separated string options (e.g., 'option1/option2/option3')"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "randSeed",
      "description": "Randomly selects one option from slash-separated list using seeded random generator. Seed is based on actorID hash and world time (changes every 6 days). Consistent for same actor and time period.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Slash-separated string options (e.g., 'option1/option2/option3')"
        }
      ],
      "optional": [],
      "aliases": ["randset", "randSet"]
    },
    {
      "name": "randSeedID",
      "description": "Randomly selects one option from slash-separated list using seeded random generator. Seed is based only on actorID hash (consistent for same actor regardless of time).",
      "required": [
        {
          "name": "Argument 1",
          "description": "Slash-separated string options (e.g., 'option1/option2/option3')"
        }
      ],
      "optional": [],
      "aliases": ["randSetID"]
    },
    {
      "name": "color",
      "description": "Changes the text color for subsequent text. Resets to upColor_text if no color specified or empty.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Color name (resolved via Data.getColor). If empty or missing, uses upColor_text"
        }
      ],
      "aliases": []
    },
    {
      "name": "keybind",
      "description": "Displays the keyboard/gamepad key binding for a specific command. Shows as uppercase, first keybind only, prettified format.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Command name to look up keybind for"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "gameTime",
      "description": "Displays the current in-game time formatted as a time string (uses GameState.convertGameTimeToString).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "sex",
      "description": "Displays different text based on the actor's gender. Shows first option if male, second if female. Uses slash-separated values.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Slash-separated gender options (e.g., 'male_text/female_text'). First for male, second for female"
        }
      ],
      "optional": [],
      "aliases": ["m/f", "mf", "gender"]
    },
    {
      "name": "pmf",
      "description": "Displays different text based on the player's gender. Shows first option if player is male, second if female. Uses slash-separated values.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Slash-separated gender options (e.g., 'male_text/female_text'). First for male, second for female"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "actorName",
      "description": "Displays an actor's name. If Argument 1 actor exists, shows that actor's name, otherwise shows the context actor's name.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID to get name from. Falls back to context actor if not found"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "commodoreName",
      "description": "Displays the name of the fleet's commodore. Retrieves commodore from the context actor's fleet.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID (used to find fleet, then gets commodore from that fleet)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "partyActorName",
      "description": "Displays the name of a party member by index. Skips if index is out of bounds.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Party member index (integer, 0-based)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "partyBoatName",
      "description": "Displays the name of a boat in the player's fleet by index. Skips if index is out of bounds.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer, 0-based)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "partyBoatType",
      "description": "Displays the type name (actor type) of a boat in the player's fleet by index. Skips if index is out of bounds.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Boat index in player fleet (integer, 0-based)"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "player",
      "description": "Displays the current player character's name (may be different from main player in certain contexts).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "pname",
      "description": "Displays the main player character's name (always returns the true main player).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "pnamefull",
      "description": "Displays the player's full name with rank title if they belong to a faction and have a rank > 0. Format: 'Rank Title PlayerName' or just 'PlayerName' if no rank.",
      "required": [],
      "optional": [],
      "aliases": ["pfullname"]
    },
    {
      "name": "prankIcon",
      "description": "Displays the player's rank icon if they belong to a faction and have rank > 0. Can optionally position the icon with X/Y offsets.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "X position offset in pixels (integer, requires Argument 2 also)"
        },
        {
          "name": "Argument 2",
          "description": "Y position offset in pixels (integer, requires Argument 1 also)"
        }
      ],
      "aliases": []
    },
    {
      "name": "prank",
      "description": "Displays the player's rank title if they belong to a faction and have rank > 0. Empty string if no rank.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "pfaction",
      "description": "Displays the player's faction name if they belong to a faction. Empty string if no faction.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "pfactionIcon",
      "description": "Displays the player's faction icon at 2x scale if they belong to a faction. Uses addIcon helper.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "talkerFaction",
      "description": "Displays the faction name of the actor currently being talked to (InputManager.I.currentActorTalkingTo). Empty if no faction.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "fleetDesc",
      "description": "Displays a description of the actor's fleet. Uses fleet's getFleetDescription() method.",
      "required": [],
      "optional": [],
      "aliases": ["fleetdesc"]
    },
    {
      "name": "fleetChat",
      "description": "Generates contextual chat text for fleet interactions based on faction favor, fleet destination, merchant status, and trade goods. May change dialog node in some cases. Complex multi-conditional behavior.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "gossip",
      "description": "Generates and displays random gossip text. Recursively calls assignText with generated gossip string. Uses Game1.currentGameState.generateGossip().",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locName",
      "description": "Displays location name. Priority: specified location ID > current location > nearest location to player. Empty if none found.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Location ID to display name for. If not specified, uses current/nearest location"
        }
      ],
      "aliases": []
    },
    {
      "name": "locName_center",
      "description": "Displays location name centered horizontally. Same location resolution as locName.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Location ID to display name for. If not specified, uses current/nearest location"
        }
      ],
      "aliases": []
    },
    {
      "name": "locFaction",
      "description": "Displays current location's faction icon and description text inline. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFaction_center",
      "description": "Displays current location's faction icon and description text, centered horizontally (centers text, adjusts for icon width). Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFactionComparison",
      "description": "Displays faction comparison text for current location. Uses location's getFactionComparisonText() method. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFactionIcon",
      "description": "Displays current location's faction icon using addItemIcon helper. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFactionName",
      "description": "Displays the name of the faction that controls the current location. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFactionNamePossessive",
      "description": "Displays the possessive form of the faction name that controls the current location (e.g., 'faction's'). Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locGoodsName",
      "description": "Displays the name of the current location's trade good item. Skips if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locGoodsPrice",
      "description": "Displays the base value of the current location's trade good. Skips if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locGoodsIcon",
      "description": "Displays the icon of the current location's trade good using addItemIcon. Skips if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locMarketRate",
      "description": "Displays current location's market rate as integer. Shows current rate and next day's rate if different (format: 'current > next'). Both values capped at minimum 20.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFoodIcon",
      "description": "Displays the icon of the current location's cafe food item using addItemIcon. Skips if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFoodName",
      "description": "Displays the name of the current location's cafe food item. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFoodDesc",
      "description": "Displays the description of the current location's cafe food item. Empty if no current location.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "locFoodEffects",
      "description": "Displays detailed food effects for current location's cafe food. Shows morale bonus and all actor value effects with durations. Multi-line formatted list with icons. Skips if no current location or no food.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "foodEffects",
      "description": "Displays detailed food effects for a specified food item. Shows morale bonus and all actor value effects with durations. Multi-line formatted list with icons at 1x scale.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Item type ID of food item to show effects for"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "actorTrivia",
      "description": "Displays trivia text about an actor. Uses actor's getTrivia() method. Skips if actor doesn't exist.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID to get trivia for"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "favAbils",
      "description": "Displays icons of an actor's 5 most frequently used abilities. Shows action icons with class-specific color palettes. Clears all text/textures if actor not found.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Actor ID to show favorite abilities for"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "journalEntries",
      "description": "Displays the total count of known journal entries as a number.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "enemiesDefeated",
      "description": "Displays the total count of all enemies defeated across all actor types. Sums all values in killsOfActorType dictionary.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "partyKOs",
      "description": "Displays the total count of knockouts across all party members (active, barracks, dead, and missing). Sums timesKOd for all actors.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "partyDeaths",
      "description": "Displays the count of dead party members. Shows size of partyActors_dead list.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "g",
      "description": "Gets and displays a global variable value as string. Empty string if no argument is given.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Global variable name to retrieve"
        }
      ],
      "aliases": ["get"]
    },
    {
      "name": "gNot0",
      "description": "Gets and displays a global variable value as string, but only if the value is not '0'. Empty string if value is '0' or variable doesn't exist.",
      "required": [],
      "optional": [
        {
          "name": "Argument 1",
          "description": "Global variable name to retrieve"
        }
      ],
      "aliases": []
    },
    {
      "name": "gDyn",
      "description": "Displays a global variable value that is dynamically evaluated each frame, making it suitable for values that change during text animation. Allocates space for 4 digits when measuring text width.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Global variable name to retrieve dynamically"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "overworldPos",
      "description": "Displays the player's current position on the overworld as latitude/longitude coordinates. Uses player position if in 'eral' zone, otherwise uses current location coordinates. Empty if game not loaded.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "clockhand",
      "description": "Displays a clock icon showing the current time of day. Shows one of 24 hour positions (ui_dayTime0 through ui_dayTime23).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "days",
      "description": "Displays the current day number (world time days + 1, as integer).",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "getHourMinTime",
      "description": "Displays the current time in hour:minute format. Uses GameState.getHourMinTime() method.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "dayname",
      "description": "Displays the name of the current day of the week. Uses GameState.whatDayIsIt().name method.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "wind",
      "description": "Displays a wind direction icon. Shows 'wind_none' if windRot is -360, otherwise shows directional wind icon snapped to nearest 45-degree increment.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "crewmorale",
      "description": "Displays crew morale icon (0-19 scale based on morale/5). In fun mode, has 10% chance to show random negative morale. Shows crewmorale0 through crewmorale19 icons.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "food",
      "description": "Displays food supply icon showing days of food remaining (0-9 scale). Calculates food count divided by daily consumption. Icon turns red (pLaser) when at 0 days. Shows ui_food0 through ui_food9.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "escortInfo",
      "description": "Displays escort mission info showing faction icon and ship count. Only shows if escort was assigned less than 721 world time units ago. Parses playerEscort global variable.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "escortTime",
      "description": "Displays remaining time for escort mission in days. Shows format '(Xd)' where X is days remaining. Only shows if time remaining > 0. Max duration is 721 world time units.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "XPbreakdown",
      "description": "Displays detailed XP gain breakdown for all crew members who gained XP. Groups crew by XP amount gained, shows portraits and XP values. Compares current XP to stored baseline. Multi-line formatted output.",
      "required": [],
      "optional": [],
      "aliases": []
    },
    {
      "name": "rFX",
      "description": "Sets the reveal effect for text animation. Stores effect name in revealFX variable.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Reveal effect name/identifier"
        }
      ],
      "optional": [],
      "aliases": ["revealFX", "rfx"]
    },
    {
      "name": "palette",
      "description": "Displays a palette swatch at 1x scale. Shows both a colored bar (pixel texture) and the actual palette colors. Positioned at specific offsets (-316,22 for bar, -50,10 for palette).",
      "required": [
        {
          "name": "Argument 1",
          "description": "Palette name in Data.palettes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "paletteBig",
      "description": "Displays a palette swatch at 2x scale. Shows colored bar and palette colors at larger size. Positioned at specific offsets (-316,22 for bar, -252,60 for palette). Advances X position by 32 pixels.",
      "required": [
        {
          "name": "Argument 1",
          "description": "Palette name in Data.palettes dictionary"
        }
      ],
      "optional": [],
      "aliases": []
    },
    {
      "name": "command",
      "description": "Adds a custom command to the commands list at current position. Stores the full tag text (text3) as command. Advances position by tiny amount (1E-05 pixels).",
      "required": [],
      "optional": [],
      "aliases": ["cmd"],
      "commands": [
        {
          "name": "globalAdd",
          "description": "Modifies a global variable by adding an integer value to it. Uses Game1.currentGameState.modGlobalVar().",
          "required": [
            {
              "name": "Argument 1",
              "description": "Global variable name to modify"
            },
            {
              "name": "Argument 2",
              "description": "Integer value to add to the global variable"
            }
          ],
          "optional": [],
          "aliases": ["gAdd", "gVarAdd"]
        },
        {
          "name": "money",
          "description": "Adds money to the player's current money total. Can be negative to subtract money.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Integer amount of money to add (can be negative)"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "fame",
          "description": "Modifies the player's fame with a specific faction. Uses Game1.currentGameState.modFame().",
          "required": [
            {
              "name": "Argument 1",
              "description": "Faction ID"
            },
            {
              "name": "Argument 2",
              "description": "Integer fame value to add (can be negative)"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "favor",
          "description": "Modifies the player's favor with a specific faction. Uses Game1.currentGameState.modFavor().",
          "required": [
            {
              "name": "Argument 1",
              "description": "Faction ID"
            },
            {
              "name": "Argument 2",
              "description": "Integer favor value to add (can be negative)"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "dmgNum",
          "description": "Displays a damage number (floating text) at the current position on screen. Uses UIManager.I.addDamageNumber().",
          "required": [
            {
              "name": "Argument 1",
              "description": "Text to display as damage number"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "task",
          "description": "Creates and executes a task immediately. Creates a new Task object and calls executeTask() with zero coordinates.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Comma-separated task string to execute"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "pause",
          "description": "Pauses execution by adjusting the timer. Subtracts (Argument 1 * 5) from the timer value.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Pause duration (float). Multiplied by 5 before subtracting from timer"
            }
          ],
          "optional": [],
          "aliases": ["p"]
        },
        {
          "name": "fx",
          "description": "Adds a visual effect to the render queue at the current text position. Uses Camera.addFXtoQueue() with 'White' color.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Effect ID/name to add to queue"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "sfx",
          "description": "Plays a sound effect.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Sound effect ID to play"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "advanceDialog",
          "description": "Advances dialog automatically after a specified delay.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Delay in seconds (float) before advancing dialog"
            }
          ],
          "optional": [],
          "aliases": []
        },
        {
          "name": "openJournal",
          "description": "Opens the journal to a specific entry. Centers window, disables interaction, plays page flip sound, and optionally shows page turn effect.",
          "required": [
            {
              "name": "Argument 1",
              "description": "Journal entry ID to open to"
            }
          ],
          "optional": [],
          "aliases": []
        }
      ]
    },
    {
      "name": "",
      "description": "Empty tag name (bare equals sign with no tag). Displays a literal '=' character.",
      "required": [],
      "optional": [],
      "aliases": []
    }
  ]
}
